import { Box, TextField } from "@mui/material";
import { useParams } from "react-router-dom";
import ItemHeader from "../components/common/ItemHeader/ItemHeader";
import React, { useContext } from "react";
import { useGetFormSubmissionById } from "../services/react-query/form_submissions/useGetFormSubmissionById";
import { Loading } from "../uikit";
import { UserSettingsCollapseKeys } from "../types/User";
import FieldsSection from "../components/common/FieldsSection/FieldsSection";
import { DisableContext } from "../contexts/DisableContextProvider";
import AccordionSection from "../components/AccordionSection";
import AppLink from "../components/common/AppLink/AppLink";
import { Launch } from "@mui/icons-material";
import { ROUTE_PATHS } from "../routes/Routes";
import { inputContainerStyling, inputDividerStyling } from "../styles/sxStyling";
import AttachmentsSection from "../components/attachments/AttachmentsSection";
import { AttachmentOwnerType } from "../types/Attachment";

export default function FormSubmissionItem() {
  const { uuid } = useParams();
  const { selfDisable } = useContext(DisableContext);
  const { data: formSubmission } = useGetFormSubmissionById({ uuid });

  if (!formSubmission) return <Loading />;

  selfDisable('other', true);

  return (
    <Box>
      <ItemHeader
        title="Form Submission"
        onSave={() => null}
        disableActions={false}
      />
      <AccordionSection title="Submission Information" collapseId={UserSettingsCollapseKeys.FORM_SUBMISSION_ITEM_INFORMATION}>
        <Box sx={inputContainerStyling}>
          <Box sx={inputDividerStyling}>
            <Box sx={{ display: 'inline-flex', gap: 1 }}>
              <TextField disabled label="Event" value={formSubmission.event_form_template?.event_display_name} />
              <AppLink to={`/${ROUTE_PATHS.EVENTS}/${formSubmission.event_form_template?.event_uuid}`} style={{ alignContent: 'center' }}>
                <Launch sx={{ color: 'black' }} />
              </AppLink>
            </Box>
          </Box>
          <Box sx={inputDividerStyling}>
            <Box sx={{ display: 'inline-flex', gap: 1 }}>
              <TextField disabled label="Contact" value={formSubmission.contact_display_name} />
              <AppLink to={`/${ROUTE_PATHS.CONTACTS}/${formSubmission.contact_uuid}`} style={{ alignContent: 'center' }}>
                <Launch sx={{ color: 'black' }} />
              </AppLink>
            </Box>
          </Box>
        </Box>
      </AccordionSection>

      <FieldsSection
        title="Submitted Values"
        fields={formSubmission.fields}
        setFields={() => null}
        collapseId={UserSettingsCollapseKeys.FORM_SUBMISSION_ITEM_FIELDS}
      />

      <AttachmentsSection ownerType={AttachmentOwnerType.FORM_SUBMISSION} ownerUuid={formSubmission.uuid} collapseId={UserSettingsCollapseKeys.FORM_SUBMISSION_ITEM_ATTACHMENTS} />
    </Box>
  );
}